import { MainMenu } from "@/features/menu"
import { useDimension } from "@/shared/store/dimensions-store"
import { useEffect, useMemo, useRef } from "react"
import { Outlet } from "react-router-dom"
import { useGetDailyBonusInfo, useUserInfoQuery } from "@/shared/api/queries"
import { useGetCatalogUser } from "@/shared/api/catalogQueries"

const Layout = () => {
  const setNavbarReference = useDimension((state) => state.setNavbarReference)
  const { data: bonus } = useGetDailyBonusInfo()
  const { isLoading: userIsLoading } = useUserInfoQuery()
  const { isLoading: catalogIsLoading } = useGetCatalogUser()

  const navbarRef = useRef<HTMLDivElement>(null)

  const hasBonusBeenShown = Boolean(sessionStorage.getItem("dailyBonusTaken"))

  const isNextBonusAvailable = useMemo(() => {
    if (!bonus?.nextBonusAvailable) return false
    return new Date(bonus.nextBonusAvailable) < new Date()
  }, [bonus?.nextBonusAvailable])

  const showNavbar =
    (!isNextBonusAvailable || hasBonusBeenShown) &&
    bonus &&
    !userIsLoading &&
    !catalogIsLoading

  useEffect(() => {
    setNavbarReference(navbarRef)
  }, [navbarRef, showNavbar])

  return (
    <>
      <div
        style={{
          paddingBottom: navbarRef?.current?.clientHeight
            ? navbarRef.current?.clientHeight + 20
            : 90,
        }}
        className="scrollbar-thin scrollbar-thumb-modal scrollbar-track-background overflow-y-auto"
      >
        <Outlet />
      </div>
      {showNavbar && <MainMenu ref={navbarRef} />}
    </>
  )
}

export default Layout
